(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wu-brand-home"] && !Shopify.designMode) return;
  try {
    

function initWuFilm(root) {
  const video = root.querySelector('.wu-film__video');
  const backdrop = root.querySelector('.wu-film__background');
  const mobile = window.matchMedia('(max-width: 760px)');
  if (!video || video.dataset.initialized) return;
  video.dataset.initialized = 'true';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function syncBackdrop() {
    if (!backdrop) return;
    if (mobile.matches || video.paused) { backdrop.pause(); return; }
    backdrop.muted = true;
    backdrop.playbackRate = video.playbackRate;
    if (backdrop.readyState > 0 && Math.abs(backdrop.currentTime - video.currentTime) > 0.3) backdrop.currentTime = video.currentTime;
    backdrop.play().catch(() => {});
  }
  video.addEventListener('play', syncBackdrop);
  video.addEventListener('pause', syncBackdrop);
  video.addEventListener('seeked', syncBackdrop);
  video.addEventListener('ratechange', syncBackdrop);
  video.addEventListener('timeupdate', syncBackdrop);
  if (backdrop) backdrop.addEventListener('loadedmetadata', syncBackdrop);
  mobile.addEventListener('change', syncBackdrop);
  let userPaused = false;
  let automaticPause = false;
  video.addEventListener('pause', () => { if (!automaticPause && !video.ended) userPaused = true; automaticPause = false; });
  video.addEventListener('play', () => { userPaused = false; });
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting && !reduceMotion.matches && !userPaused) {
      video.muted = true;
      video.play().catch(() => {});
    } else if (!video.paused) {
      automaticPause = true;
      video.pause();
    }
  }), { threshold: 0.3 });
  observer.observe(video);
  document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) { observer.disconnect(); video.pause(); if (backdrop) backdrop.pause(); } });
  reduceMotion.addEventListener('change', event => { if (event.matches && !video.paused) { automaticPause = true; video.pause(); } });
}
document.querySelectorAll('[data-wu-film]').forEach(initWuFilm);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wu-film]').forEach(initWuFilm));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wu-catalog"] && !Shopify.designMode) return;
  try {
    
function initWuCatalog(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const buttons = root.querySelectorAll('[data-category]');
  const cards = root.querySelectorAll('[data-look-category]');
  const count = root.querySelector('[data-look-count]');
  function filterCategory(requested) {
    const category = Array.from(buttons).some(button => button.dataset.category === requested) ? requested : 'all';
    let visible = 0;
    cards.forEach(card => {
      card.hidden = category !== 'all' && card.dataset.lookCategory !== category;
      if (!card.hidden) visible++;
    });
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
    count.textContent = visible;
  }
  buttons.forEach(button => button.addEventListener('click', () => {
    const category = button.dataset.category;
    filterCategory(category);
    const url = new URL(window.location.href);
    url.hash = category === 'all' ? '' : category;
    window.history.replaceState(null, '', url);
  }));
  const applyHash = () => filterCategory(window.location.hash.slice(1));
  applyHash();
  window.addEventListener('hashchange', applyHash);
  document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) window.removeEventListener('hashchange', applyHash); });
}
document.querySelectorAll('[data-wu-catalog]').forEach(initWuCatalog);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wu-catalog]').forEach(initWuCatalog));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wu-series"] && !Shopify.designMode) return;
  try {
    
function initWuSeries(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const buttons = root.querySelectorAll('[data-series-filter]');
  const cards = root.querySelectorAll('[data-series-tags]');
  const count = root.querySelector('[data-series-count]');
  function filter(requested) {
    const category = Array.from(buttons).some(button => button.dataset.seriesFilter === requested) ? requested : 'all';
    let visible = 0;
    cards.forEach(card => { card.hidden = category !== 'all' && !card.dataset.seriesTags.split(',').includes(category); if (!card.hidden) visible++; });
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.seriesFilter === category)));
    count.textContent = visible;
  }
  buttons.forEach(button => button.addEventListener('click', () => {
    filter(button.dataset.seriesFilter);
    const url = new URL(window.location.href);
    url.hash = button.dataset.seriesFilter === 'all' ? '' : button.dataset.seriesFilter;
    window.history.replaceState(null, '', url);
  }));
  const applyHash = () => filter(window.location.hash.slice(1));
  applyHash();
  window.addEventListener('hashchange', applyHash);
  document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) window.removeEventListener('hashchange', applyHash); });
}
document.querySelectorAll('[data-wu-series]').forEach(initWuSeries);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wu-series]').forEach(initWuSeries));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wu-style-detail"] && !Shopify.designMode) return;
  try {
    
function initWuStyleDetail(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const buttons = root.querySelectorAll('[data-colour]');
  const photos = root.querySelectorAll('[data-photo-colour]');
  const selected = root.querySelector('[data-selected-colour]');
  function choose(requested) {
    const button = Array.from(buttons).find(item => item.dataset.colour === requested) || buttons[0];
    photos.forEach(photo => { photo.hidden = photo.dataset.photoColour !== button.dataset.colour; });
    buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    selected.textContent = button.textContent.trim();
  }
  buttons.forEach(button => button.addEventListener('click', () => {
    choose(button.dataset.colour);
    const url = new URL(window.location.href);
    url.hash = 'colour-' + button.dataset.colour;
    window.history.replaceState(null, '', url);
  }));
  const applyHash = () => choose(window.location.hash.replace('#colour-', ''));
  applyHash();
  window.addEventListener('hashchange', applyHash);
  document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) window.removeEventListener('hashchange', applyHash); });
}
document.querySelectorAll('[data-wu-style-detail]').forEach(initWuStyleDetail);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wu-style-detail]').forEach(initWuStyleDetail));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wu-trouser-detail"] && !Shopify.designMode) return;
  try {
    
function initWuTrouserDetail(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const buttons = root.querySelectorAll('[data-colour]');
  const photos = root.querySelectorAll('[data-photo-colour]');
  const selected = root.querySelector('[data-selected-colour]');
  function choose(requested) {
    const button = Array.from(buttons).find(item => item.dataset.colour === requested) || buttons[0];
    photos.forEach(photo => { photo.hidden = photo.dataset.photoColour !== button.dataset.colour; });
    buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    selected.textContent = button.textContent.trim();
  }
  buttons.forEach(button => button.addEventListener('click', () => {
    choose(button.dataset.colour);
    const url = new URL(window.location.href);
    url.hash = 'colour-' + button.dataset.colour;
    window.history.replaceState(null, '', url);
  }));
  const applyHash = () => choose(window.location.hash.replace('#colour-', ''));
  applyHash();
  window.addEventListener('hashchange', applyHash);
  document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) window.removeEventListener('hashchange', applyHash); });
}
document.querySelectorAll('[data-wu-trouser-detail]').forEach(initWuTrouserDetail);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wu-trouser-detail]').forEach(initWuTrouserDetail));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wu-trousers"] && !Shopify.designMode) return;
  try {
    
function initWuTrousers(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const buttons = root.querySelectorAll('[data-trouser-filter]');
  const cards = root.querySelectorAll('[data-trouser-tags]');
  const count = root.querySelector('[data-trouser-count]');
  function filter(requested) {
    const category = Array.from(buttons).some(button => button.dataset.trouserFilter === requested) ? requested : 'all';
    let visible = 0;
    cards.forEach(card => { card.hidden = category !== 'all' && !card.dataset.trouserTags.split(',').includes(category); if (!card.hidden) visible++; });
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.trouserFilter === category)));
    count.textContent = visible;
  }
  buttons.forEach(button => button.addEventListener('click', () => {
    filter(button.dataset.trouserFilter);
    const url = new URL(window.location.href);
    url.hash = button.dataset.trouserFilter === 'all' ? '' : button.dataset.trouserFilter;
    window.history.replaceState(null, '', url);
  }));
  const applyHash = () => filter(window.location.hash.slice(1));
  applyHash();
  window.addEventListener('hashchange', applyHash);
  document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) window.removeEventListener('hashchange', applyHash); });
}
document.querySelectorAll('[data-wu-trousers]').forEach(initWuTrousers);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wu-trousers]').forEach(initWuTrousers));

  } catch(e) { console.error(e); }
})();
})();
